import type { BillingVersion, Plan } from '~/features/usage/useBilling'
import { Check } from 'lucide-react'
import { billingPlan } from '~/features/billing/constants'
import { getPlanColor } from '~/utils/getPlanColor'

type PlanInclusionsProps = {
  plan: Plan
  billingVersion: BillingVersion
}

export const PlanInclusions = ({ plan, billingVersion }: PlanInclusionsProps) => {
  const planColor = getPlanColor(plan)

  return (
    <div className="flex flex-col gap-3 overflow-y-auto" data-accent-color={planColor}>
      {billingPlan[plan].inclusions[billingVersion].map((feature) => (
        <div key={feature} className="flex items-center gap-2">
          <Check className={`h-5 flex-none stroke-[1.5px] text-accent-9`} />
          <p className="text-sm text-muted-foreground">{feature}</p>
        </div>
      ))}
    </div>
  )
}
